import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { Country } from '../../../../../components/actionable-filter-pill/connected/shipping/country';
import messages from './messages';

export default {
  id: 'country',
  displayName: <FormattedMessage {...messages.country} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShipToCountryCode',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER, criteriaInformations, existingFiltersHelpers);
  },
  actionableFilterPill: Country,
  allowsMultipleSelection: true,
};
